<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <!-- RIGHT HAND SIDE DRAWER-->
  <v-navigation-drawer
    v-if="$store.state.user.logged_in"
    v-model="$store.state.app.drawerRight"
    app
    class="trade-blue-text outline grey lighten-4"
    clipped
    mini-variant
    mini-variant-width="500"
    right
    temporary
  >
    <div v-if="typeof user !== 'undefined'">
      <v-layout class="justify-end mb-0" row>
        <v-btn
          class="v-btn--outlined trade-blue white--text mr-10 mt-2 justify-end rounded"
          elevation="0"
          small
          @click="$store.state.app.drawerRight = false"
        >
          <v-icon left>mdi-cancel</v-icon>
          Close
        </v-btn>
      </v-layout>
      <v-layout class="justify-center mt-0 pa-0" row>
        <v-card class="grey lighten-4" elevation="0">
          <v-card-title class="trade-blue-text align-center ml-4 pa-0"
            >User Info
            <v-btn class="caption ml-2" small @click="send_mail()"> (Update)</v-btn>
          </v-card-title>
          <v-card-text v-if="true">
            <v-data-table
              :headers="[
                {text: 'Setting', value: 'item', class: 'trade-blue'},
                {text: 'Value', value: 'value', class: 'trade-blue'},
              ]"
              :items="user_items"
              :items-per-page="5"
              class="elevation-1 caption"
              dark
              dense
              disable-filtering
              disable-pagination
              disable-sort
              hide-default-footer
              hide-default-header
            >
              <template v-slot:item="{item}">
                <tr v-if="item.item === 'Mobile'" class="grey darken-3">
                  <td>{{ item.item }}</td>
                  <td>
                    <v-text-field
                      id="mobile_entry"
                      v-model="user.fields.cell_phone"
                      class="mt-2 mb-0 pa-0"
                      dense
                      filled
                      label="Edit"
                      outlined
                      @change="update_field(user['profile_pk'], 'cell_phone', $event)"
                    ></v-text-field>
                  </td>
                </tr>

                <template v-else-if="item.item === 'Include_Mobile'">
                  <tr class="grey darken-3 ma-0 pa-0">
                    <td class="mt-2 pt-0 pb-0 mb-0">Include mobile in reports:</td>
                    <td>
                      <v-checkbox
                        v-model="user.fields.include_cell_phone_in_report"
                        @change="
                          update_field(
                            user['profile_pk'],
                            'include_cell_phone_in_report',
                            user.fields.include_cell_phone_in_report ? 1 : 0,
                          )
                        "
                      ></v-checkbox>
                    </td>
                  </tr>
                  <tr class="grey darken-3 ma-0 pa-0">
                    <td class="mt-2 pt-0 pb-0 mb-0">Economic overview in report:</td>
                    <td>
                      <v-checkbox
                        v-model="app_data.include_overview_sections_in_report"
                      ></v-checkbox>
                    </td>
                  </tr>
                  <tr class="grey darken-3 ma-0 pa-0">
                    <td class="mt-2 pt-0 pb-0 mb-0">
                      Apply default filters at startup<br />(the current default is entry
                      {{ startup_value_list_ix }} in the custom filter list)
                    </td>
                    <td>
                      <v-checkbox
                        v-model="load_with_filters"
                        @change="set_startup_filters_state"
                      ></v-checkbox>
                    </td>
                  </tr>
                  <tr class="grey darken-3 ma-0 pa-0">
                    <td class="mt-2 pt-0 pb-0 mb-0">Update filters</td>
                    <td>
                      <v-checkbox
                        v-model="$store.state.app.update_filters_selection_on_each_call"
                      ></v-checkbox>
                    </td>
                  </tr>
                </template>

                <tr v-else>
                  <td>{{ item.item }}</td>
                  <td>{{ item.value }}</td>
                </tr>
              </template>
            </v-data-table>

            <v-card-title class="trade-blue-text justify-start mt-0 mb-0 ml-0 pl-0"
              >Application setttings
            </v-card-title>
            <div class="outline mt-0 pb-2 pl-2 pr-2">
              <v-card-text>
                <v-autocomplete
                  v-model="magnitude_setting"
                  :items="display_magnitude"
                  background-color="white"
                  class="pr-1 font-weight-light mt-3"
                  color="green"
                  dense
                  hide-details="true"
                  item-color="green"
                  label="Default Display Magnitude"
                  outlined
                  prepend-icon="mdi-decimal"
                  @change="set_magnitude($event)"
                />

                <v-autocomplete
                  v-model="currency_setting"
                  :items="get_exchange_rate"
                  background-color="white"
                  class="pr-1 font-weight-light mt-3"
                  color="green"
                  dense
                  hide-details="true"
                  item-color="green"
                  item-text="CurrencyName"
                  label="Default Display Currency"
                  outlined
                  prepend-icon="mdi-currency-usd"
                  return-object
                  @change="set_currency($event)"
                />
              </v-card-text>

              <v-btn block class="mt-0" dark @click="clearStorage"
                >Clear storage and reload
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
    </div>

    <v-snackbar v-model="email_clicked" :timeout="2000" color="green lighten-1" top>
      <h3 class="text-center pa-2 black--text lighten-2">
        PLease wait for your email program to open with a pre-populated message
      </h3>
      <!-- /.caption -->
    </v-snackbar>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import swal from 'sweetalert';
import {eventBus} from '@/main';

export default {
  name: 'rightHandDrawer',
  components: {},

  data() {
    return {
      load_with_filters: false,
      mobile_number: '12234',
      changes_made: false,
      fullscreen_setting: null,
      internetSpeed: 0,
      email_clicked: false,
      currency_setting: {
        id: null,
        T_Year: null,
        Version: null,
        C_Code: null,
        CurrencyName: null,
        Currency: null,
        TW_FX_Rate: null,
      },
      startup_value_list_ix: 0,
      magnitude_setting: {
        divider: 1000,
        prefix: 'Mn',
        long_name: 'Millions',
      },
      display_magnitude: [
        {text: "'000s", value: {divider: 1, prefix: "'000s", long_name: 'Thousands'}},
        {
          text: 'Millions',
          value: {divider: 1000, prefix: 'Mn', long_name: 'Millions'},
        },
        {
          text: 'Billions',
          value: {divider: 1000000, prefix: 'Bn', long_name: 'Billions'},
        },
      ],
    };
  },

  async mounted() {
    if (localStorage.getItem('fullscreen')) {
      this.fullscreen_setting = localStorage.getItem('fullscreen');
    }

    if (localStorage.getItem('startup_with_filters') === null) {
      this.load_with_filters = false;
    } else {
      this.load_with_filters = JSON.parse(localStorage.getItem('startup_with_filters'));
    }

    if (localStorage.getItem('magnitude') === null) {
      localStorage.setItem('magnitude', JSON.stringify(this.magnitude_setting));
    } else {
      this.magnitude_setting = JSON.parse(localStorage.getItem('magnitude'));
    }

    if (localStorage.getItem('currency') === null) {
      // console.log(this.$store.state.user.userServerInfo)
      if ('exchange_rate' in this.$store.state.user.userServerInfo) {
        await localStorage.setItem(
          'currency',
          JSON.stringify(this.$store.state.user.userServerInfo.exchange_rate[0]),
        );
      }
    } else {
      this.currency_setting = JSON.parse(localStorage.getItem('currency'));
    }
  },
  watch: {
    drawer_open() {
      this.startup_value_list_ix =
        JSON.parse(localStorage.getItem('custom_filters_selected'))[
          'startup_value_list_ix'
        ] + 1;
    },
    fullscreen_setting(newValue) {
      this.changes_made = true;
      this.fullscreen_setting = newValue;
      localStorage.setItem('fullscreen', this.fullscreen_setting);
      if (this.fullscreen_setting === 'true') {
        document.documentElement.requestFullscreen();
      }
    },
  },
  computed: {
    ...mapGetters(['user', 'app_data', 'get_exchange_rate']),

    drawer_open() {
      return this.$store.state.app.drawerRight;
    },
    user_items() {
      return [
        {
          item: 'Full name',
          value: this.fullName,
        },
        {
          item: 'Username',
          value: this.userInfo,
        },
        {
          item: 'Position',
          value:
            typeof this.user !== 'undefined'
              ? this.user.fields['user_job_description']
              : 'No description',

          // $store.state.user.userServerInfo['user']['fields'][
          //   'user_job_description'
          // ],
        },
        {
          item: 'Institution',
          value: this.institutionInfo,
        },
        {
          item: 'Address ',
          value:
            typeof this.user !== 'undefined'
              ? this.user.fields['adress_line1']
              : 'No Adress',
          // $store.state.this.user.this.userServerInfo['this.user']['fields']['adress_line1'],
        },
        {
          item: 'Address ',

          value:
            typeof this.user !== 'undefined'
              ? this.user.fields['adress_line2']
              : 'No Adress',
          // $store.state.this.user.this.userServerInfo['this.user']['fields']['adress_line2'],
        },
        {
          item: 'Address ',
          value:
            typeof this.user !== 'undefined'
              ? this.user.fields.adress_line3
              : 'No Adress',
          // $store.state.this.user.this.userServerInfo['this.user']['fields']['adress_line3'],
        },
        {
          item: 'E-Mail',
          value: typeof this.user !== 'undefined' ? this.user.fields.email : 'No email',
        },
        {
          item: 'Landline',
          value: typeof this.user !== 'undefined' ? this.user.fields.phone : 'No phone',
        },
        {
          item: 'Mobile',
          value:
            typeof this.user !== 'undefined'
              ? this.user.fields.cell_phone
              : 'No mobile number.',
        },
        {
          item: 'Include_Mobile',
          value: '',
        },
      ];
    },
    email_text() {
      if (typeof this.user !== 'undefined') {
        return `mailto:martin.cameron@tradeadvisory.co.za
            ?subject=Update User Information for User -  ${this.userInfo}
            &body= Kindly change the system informaton to the values indicated below, %0d%0a %0d%0a Change User Name from ${
              this.userInfo
            } to _____ %0d%0a Change Cellphone from ${
          this.user.fields.phone
        } to _______ %0d%0a Change Email from ${
          this.user.fields.email
        } to ______ %0d%0a %0d%0a kind regards %0d%0a ${this.userInfo} %0d%0a ${
          this.institutionInfo
        }`;
      } else {
        return 'cannot build email message';
      }
    },

    userInfo() {
      try {
        return this.$store.state.user.userServerInfo.user.fields.user[0];
      } catch (e) {
        return undefined;
      }
    },
    fullName() {
      try {
        return this.$store.state.user.userServerInfo.user['fullname'];
      } catch (e) {
        return undefined;
      }
    },
    institutionInfo() {
      try {
        return this.$store.state.user.userServerInfo.user.fields.institution[0].fields
          .institution_name;
      } catch (e) {
        return undefined;
      }
    },
  },
  methods: {
    ...mapMutations(['set_value_mulitplier', 'set_exchange_rate']),

    set_startup_filters_state() {
      window.localStorage.setItem('startup_with_filters', this.load_with_filters);
    },
    update_field(pk, field_name, new_value) {
      // console.log(JSON.stringify(this.user))
      // alert('changing ' + pk + ' ' + field_name + ' ' + new_value);
      let resp_config = {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      };

      if (field_name === 'cell_phone') {
        this.user.fields.cell_phone = new_value;
      }

      swal('Updating user settings', {
        buttons: false,
        timer: 2000,
      });
      let url =
        this.$store.getters.baseUrl +
        'update_profile' +
        '/' +
        pk +
        '/' +
        field_name +
        '/' +
        new_value;

      this.axios
        .get(url, resp_config)
        .then(() => {
          // console.log('sucess changing user value');
          swal('User settings updated.');
        })
        .catch(() => {
          // console.log('error changing user value');
          swal('There was an error updating the user settings', {
            buttons: false,
            timer: 2000,
          });
        });
    },

    send_mail() {
      this.email_clicked = true;
      window.open(this.email_text, '_self');
    },
    clearStorage() {
      this.$store.state.app.drawerRight = false;

      swal(
        'Warning: If you clear the application storage the application will restart and reset all local data to the original state.',

        {
          icon: 'info',

          buttons: {
            word: {
              text: 'Yes',
              value: 'yes',
            },
            email: {
              text: 'Cancel',
              value: 'cancel',
            },
          },
        },
      ).then(value => {
        switch (value) {
          case 'yes':
            swal(
              'Application will restart.\n\nPlease be patient while application data downloads.',
              {
                icon: 'info',

                buttons: {
                  ok: {
                    text: 'Restart',
                    value: 'ok',
                  },
                },
              },
            ).then(async () => {
              // save login path
              let reload_url = localStorage.getItem('reload_url');
              await localStorage.clear();
              localStorage.setItem('reload_url', reload_url);
              await sessionStorage.clear();
              await this.$clearStorage();
              await location.reload();
            });
            break;
          case 'cancel':
            break;
        }
      });
    },
    set_magnitude(event) {
      localStorage.setItem('magnitude', JSON.stringify(event));
      //code below changes the value of the selectors_changed_mag_currency (toggle)
      //the change will be picked up by the topFilters computed value
      //the topFilter watch function will then sync the filters

      this.set_value_mulitplier(event);
      let temp = this.$store.state.tradeDSM.selectors_changed_mag_currency || 0;
      this.$store.state.tradeDSM.selectors_changed_mag_currency = !temp;
    },
    set_currency(event) {
      localStorage.setItem('currency', JSON.stringify(event));

      this.set_exchange_rate(event);
      eventBus.$emit('CURRENCY_CHANGED');
      document.getElementById('display_currency').blur();

      //code below changes the value of the selectors_changed_mag_currency (toggle)
      //the change will be picked up by the topFilters computed value
      //the topFilter watch function will then sync the filters
      let temp = this.$store.state.tradeDSM.selectors_changed_mag_currency || 0;
      this.$store.state.tradeDSM.selectors_changed_mag_currency = !temp;
    },
  },
};
</script>

<style>
#mobile_entry {
  color: #39ff14;
}
</style>
